import styled, { createGlobalStyle } from 'styled-components';
import { Card, Button, Input, Select, Badge, Modal } from 'antd';

export const Container = styled.div`
  padding: 24px;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h1<{ $isDark: boolean }>`
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -2px;
  margin: 0;
  color: ${props => props.$isDark ? '#fff' : '#1a202c'};
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p<{ $isDark: boolean }>`
  font-size: 14px;
  margin: 0;
  color: ${props => props.$isDark ? '#a0aec0' : '#718096'};
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledSearchInput = styled(Input)<{ $isDark: boolean }>`
  max-width: 400px;
  background: ${props => props.$isDark ? '#2d3748' : '#ffffff'} !important;
  border: 1px solid ${props => props.$isDark ? '#4a5568' : '#d9d9d9'} !important;
  border-radius: 8px;
  color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
  font-size: 16px;
  transition: all 0.2s ease;

  &::placeholder {
    color: ${props => props.$isDark ? '#718096' : '#bfbfbf'} !important;
  }

  &:hover {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
  }

  &:focus {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
    box-shadow: ${props => props.$isDark ? '0 0 0 2px rgba(99, 179, 237, 0.2)' : '0 0 0 2px rgba(24, 144, 255, 0.2)'} !important;
  }

  .ant-input-prefix {
    color: ${props => props.$isDark ? '#a0aec0' : '#8c8c8c'};
  }
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const StyledSelectFilter = styled(Select)<{ $isDark: boolean }>`
  min-width: 200px;
  
  .ant-select-selector {
    background: ${props => props.$isDark ? '#2d3748' : '#ffffff'} !important;
    border: 1px solid ${props => props.$isDark ? '#4a5568' : '#d9d9d9'} !important;
    border-radius: 8px !important;
    color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
    font-size: 16px;

    .ant-select-selection-placeholder {
      color: ${props => props.$isDark ? '#718096' : '#bfbfbf'} !important;
    }

    .ant-select-selection-item {
      color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
    }
  }

  &:hover .ant-select-selector {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
  }

  &.ant-select-focused .ant-select-selector {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
    box-shadow: ${props => props.$isDark ? '0 0 0 2px rgba(99, 179, 237, 0.2)' : '0 0 0 2px rgba(24, 144, 255, 0.2)'} !important;
  }

  .ant-select-arrow {
    color: ${props => props.$isDark ? '#a0aec0' : '#8c8c8c'} !important;
  }

  // Dropdown menu styling
  .ant-select-dropdown {
    background: ${props => props.$isDark ? '#1a202c' : '#ffffff'} !important;
    border-radius: 8px;
    box-shadow: ${props => props.$isDark ? '0 4px 12px rgba(0, 0, 0, 0.5)' : '0 4px 12px rgba(0, 0, 0, 0.15)'} !important;
  }

  .ant-select-item {
    color: ${props => props.$isDark ? '#e2e8f0' : '#262626'} !important;
    
    &:hover {
      background: ${props => props.$isDark ? '#2d3748' : '#f5f5f5'} !important;
    }

    &.ant-select-item-option-selected {
      background: ${props => props.$isDark ? '#2d3748' : '#e6f7ff'} !important;
      color: ${props => props.$isDark ? '#fff' : '#1890ff'} !important;
    }

    &.ant-select-item-option-active {
      background: ${props => props.$isDark ? '#4a5568' : '#f5f5f5'} !important;
    }
  }
  
  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const StyledCard = styled(Card)<{ $isDark: boolean }>`
  border-radius: 12px;
  background: ${props => props.$isDark ? '#1a202c' : '#fff'};
  border: 1px solid ${props => props.$isDark ? '#4a5568' : '#e2e8f0'};
  box-shadow: ${props => props.$isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)'};
  
  .ant-card-head {
    background: ${props => props.$isDark ? '#2d3748' : '#f7fafc'};
    border-bottom: 1px solid ${props => props.$isDark ? '#4a5568' : '#e2e8f0'};
  }
  
  .ant-card-body {
    padding: 24px;
  }
`;

export const StoreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
`;

export const StoreInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const StoreDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const StoreName = styled.h3<{ $isDark: boolean }>`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: ${props => props.$isDark ? '#fff' : '#2d3748'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MerchantName = styled.p<{ $isDark: boolean }>`
  font-size: 14px;
  margin: 0;
  color: ${props => props.$isDark ? '#a0aec0' : '#718096'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StoreActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const PairCard = styled(Card)<{ $isConnected: boolean; $isDark: boolean }>`
  border: 2px solid ${props => props.$isConnected 
    ? (props.$isDark ? '#48bb78' : '#68d391') 
    : (props.$isDark ? '#4a5568' : '#e2e8f0')};
  border-radius: 12px;
  transition: all 0.3s ease;
  background: ${props => props.$isDark ? '#2d3748' : '#f7fafc'};
  
  &:hover {
    border-color: ${props => props.$isConnected 
      ? (props.$isDark ? '#68d391' : '#48bb78') 
      : (props.$isDark ? '#718096' : '#cbd5e0')};
    box-shadow: ${props => props.$isDark 
      ? '0 4px 12px rgba(72, 187, 120, 0.2)' 
      : '0 4px 12px rgba(0,0,0,0.1)'};
  }
`;

export const DeviceSection = styled.div<{ $type: 'kiosk' | 'reader' | 'other'; $isDark: boolean }>`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid;
  background: ${props => {
    if (props.$type === 'kiosk') {
      return props.$isDark ? '#1e3a5f' : '#ebf8ff';
    } else if (props.$type === 'reader') {
      return props.$isDark ? '#1a3a2e' : '#f0fff4';
    }
    return props.$isDark ? '#2d3748' : '#f7fafc';
  }};
  border-color: ${props => {
    if (props.$type === 'kiosk') {
      return props.$isDark ? '#3182ce' : '#90cdf4';
    } else if (props.$type === 'reader') {
      return props.$isDark ? '#38a169' : '#9ae6b4';
    }
    return props.$isDark ? '#4a5568' : '#e2e8f0';
  }};
`;

export const DeviceName = styled.h4<{ $isDark: boolean; $color?: string }>`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: ${props => props.$color || (props.$isDark ? '#fff' : '#2d3748')};
`;

export const DeviceIdentifier = styled.p<{ $isDark: boolean; $color?: string }>`
  font-size: 14px;
  margin: 0;
  font-family: 'Monaco', 'Menlo', monospace;
  color: ${props => props.$color || (props.$isDark ? '#a0aec0' : '#718096')};
`;

export const ConnectionLine = styled.div<{ $isConnected: boolean; $isDark: boolean }>`
  width: 2px;
  height: 32px;
  background: ${props => props.$isConnected 
    ? (props.$isDark ? '#48bb78' : '#68d391') 
    : (props.$isDark ? '#4a5568' : '#cbd5e0')};
  position: relative;
  margin: 8px auto;
`;

export const ConnectionIcon = styled.div<{ $isConnected: boolean; $isDark: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${props => props.$isDark ? '#1a202c' : '#fff'};
  border-radius: 50%;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  gap: 8px;
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h3<{ $isDark: boolean }>`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: ${props => props.$isDark ? '#fff' : '#2d3748'};
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
`;

export const EmptyStateIcon = styled.div<{ $isDark: boolean }>`
  font-size: 48px;
  color: ${props => props.$isDark ? '#4a5568' : '#cbd5e0'};
`;

export const EmptyStateText = styled.p<{ $isDark: boolean }>`
  font-size: 18px;
  margin: 0;
  color: ${props => props.$isDark ? '#a0aec0' : '#718096'};
`;

export const EmptyStateSubtext = styled.p<{ $isDark: boolean }>`
  font-size: 14px;
  margin: 0;
  color: ${props => props.$isDark ? '#718096' : '#a0aec0'};
  text-align: center;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export const FormActionsRight = styled.div`
  display: flex;
  gap: 12px;
`;

export const StyledFormItem = styled.div`
  margin-bottom: 24px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1025px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const OtherDevicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1025px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

// DevicePairCard styles
export const PairCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DeviceSectionContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const DeviceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const StyledBadge = styled(Badge)<{ $isDark: boolean; $color?: string }>`
  .ant-badge-count {
    background-color: ${props => props.$color || (props.$isDark ? '#3182ce' : '#3182ce')};
    color: #fff;
    padding: 1px 12px;
    border-radius: 12px;
    font-size: 12px;
  }
`;

export const ConnectionStatusContainer = styled.div`
  text-align: center;
  padding: 8px 0;
`;

export const StyledConnectionBadge = styled(Badge)<{ $isDark: boolean }>`
  .ant-badge-status-text {
    color: ${props => props.$isDark ? '#fff' : '#2d3748'};
  }
`;


// DeviceCard styles
export const DeviceCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DeviceCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DeviceCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const DeviceCardTitle = styled.h4<{ $isDark: boolean }>`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: ${props => props.$isDark ? '#fff' : '#2d3748'};
`;

export const DeviceCardIdentifier = styled.p<{ $isDark: boolean }>`
  margin: 0;
  font-size: 14px;
  font-family: monospace;
  color: ${props => props.$isDark ? '#a0aec0' : '#718096'};
`;

export const DeviceTypeBadge = styled.span<{ $isDark: boolean }>`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => props.$isDark ? '#4a5568' : '#edf2f7'};
  color: ${props => props.$isDark ? '#fff' : '#2d3748'};
`;

export const DeviceCardDivider = styled.div<{ $isDark: boolean }>`
  border-top: 1px solid ${props => props.$isDark ? '#4a5568' : '#e2e8f0'};
  padding-top: 12px;
`;

export const DeviceCardActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledDeviceCard = styled(Card)<{ $isDark: boolean }>`
  background: ${props => props.$isDark ? '#2d3748' : '#f7fafc'};
  border: 1px solid ${props => props.$isDark ? '#4a5568' : '#e2e8f0'};
`;

// StoreGroup styles
export const StoreIconWrapper = styled.div<{ $isDark: boolean }>`
  color: ${props => props.$isDark ? '#63b3ed' : '#3182ce'};
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionIconWrapper = styled.div<{ $isDark: boolean; $color?: string }>`
  color: ${props => props.$color || (props.$isDark ? '#a0aec0' : '#718096')};
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BadgeContainer = styled(Badge)<{ $isDark: boolean; $display?: string }>`
  .ant-badge-count {
    background-color: ${props => props.$isDark ? '#3182ce' : '#3182ce'};
    color: #fff;
    padding: 1px 12px;
    border-radius: 12px;
    font-size: 12px;
    display: ${props => props.$display || 'inline-block'};
  }
`;

export const BadgeContainerSmall = styled(Badge)<{ $isDark: boolean; $display?: string }>`
  .ant-badge-count {
    background-color: ${props => props.$isDark ? '#3182ce' : '#3182ce'};
    color: #fff;
    padding: 1px 8px;
    border-radius: 12px;
    font-size: 12px;
    display: ${props => props.$display || 'inline-block'};
  }
`;

export const SectionBadge = styled(Badge)<{ $isDark: boolean; $bgColor?: string }>`
  .ant-badge-count {
    background-color: ${props => props.$bgColor || (props.$isDark ? '#718096' : '#a0aec0')};
    color: #fff;
    padding: 1px 8px;
    border-radius: 8px;
    font-size: 12px;
  }
`;

export const ExpandableContent = styled.div`
  padding-top: 16px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 24px;
`;


export const StoreGroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Connection Icon styles
export const ConnectionIconWrapper = styled.div<{ $isConnected: boolean; $isDark: boolean }>`
  color: ${props => props.$isConnected 
    ? (props.$isDark ? '#48bb78' : '#38a169') 
    : (props.$isDark ? '#718096' : '#a0aec0')};
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Button Styles
export const PrimaryButton = styled(Button)`
  background-color: #2D6CCA !important;
  border-color: #2D6CCA !important;
  color: white !important;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  height: auto;
  padding: 8px 16px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2563c7 !important;
    border-color: #2563c7 !important;
    color: white !important;
  }

  &:focus {
    background-color: #2D6CCA !important;
    border-color: #2D6CCA !important;
    color: white !important;
  }

  .anticon {
    color: white !important;
  }
`;

export const CancelButton = styled(Button)`
  background-color: #ededed !important;
  border: 0 !important;
  border-radius: 8px;
  color: #121212 !important;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  margin-left: 24px;
  padding: 8px 16px;
  text-align: center;
  transition: all 0.2s ease;
  height: auto;

  &:hover {
    background-color: #e0e0e0 !important;
    color: #121212 !important;
    border: 0 !important;
  }

  &:focus {
    background-color: #ededed !important;
    color: #121212 !important;
    border: 0 !important;
  }
`;

export const IconButtonStyled = styled(Button)<{ $isDark: boolean; $color?: string }>`
  color: ${props => props.$color || (props.$isDark ? '#90cdf4' : '#3182ce')} !important;
  border: none !important;
  background: transparent !important;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.$isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'} !important;
    color: ${props => props.$color || (props.$isDark ? '#90cdf4' : '#3182ce')} !important;
  }

  &:focus {
    background-color: ${props => props.$isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'} !important;
    color: ${props => props.$color || (props.$isDark ? '#90cdf4' : '#3182ce')} !important;
  }

  .anticon {
    color: ${props => props.$color || (props.$isDark ? '#90cdf4' : '#3182ce')} !important;
  }
`;

export const DangerButton = styled(Button)`
  color: #ff4d4f !important;
  border: none !important;
  background: transparent !important;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 77, 79, 0.1) !important;
    color: #ff4d4f !important;
  }

  &:focus {
    background-color: rgba(255, 77, 79, 0.1) !important;
    color: #ff4d4f !important;
  }

  .anticon {
    color: #ff4d4f !important;
  }
`;

// ActionIconButton - matches Manager/User tab style
export const ActionIconButton = styled.div<{ iconColor?: string; $isDark: boolean }>`
  align-items: center;
  border: 1px solid ${(props) => props.$isDark ? '#434343' : '#eee'};
  border-radius: 10px;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 8px;
  width: 30px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  background: ${(props) => props.$isDark ? 'transparent' : 'inherit'};

  svg {
    transition: color 0.2s;
  }

  &:hover {
    background-color: ${(props) => {
      const iconColor = props.iconColor || '#2D6CCA';
      if (iconColor === '#f5222d') {
        return props.$isDark ? 'rgba(245, 34, 45, 0.2)' : 'rgba(245, 34, 45, 0.1)';
      }
      return props.$isDark ? 'rgba(45, 108, 202, 0.2)' : 'rgba(45, 108, 202, 0.1)';
    }} !important;

    svg {
      color: ${(props) => props.iconColor || '#2D6CCA'} !important;
    }
  }
`;

export const ToggleButtonStyled = styled(Button)<{ $isDark: boolean }>`
  color: ${props => props.$isDark ? '#fff' : '#2d3748'} !important;
  border: none !important;
  background: transparent !important;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.$isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'} !important;
    color: ${props => props.$isDark ? '#fff' : '#2d3748'} !important;
  }

  &:focus {
    background-color: ${props => props.$isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'} !important;
    color: ${props => props.$isDark ? '#fff' : '#2d3748'} !important;
  }

  .anticon {
    color: ${props => props.$isDark ? '#fff' : '#2d3748'} !important;
  }
`;

// Index styles
export const AddButton = styled(PrimaryButton)`
  background-color: #2D6CCA !important;
  border-color: #2D6CCA !important;
  
  &:hover {
    background-color: #2563c7 !important;
    border-color: #2563c7 !important;
  }
`;

export const StyledModal = styled(Modal)<{ $isDark: boolean }>`
  .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.45) !important;
    backdrop-filter: blur(4px);
  }

  .ant-modal-container {
    background: ${props => props.$isDark ? '#1a202c' : '#ffffff'} !important;
  }

  & ~ .ant-modal-container,
  & + .ant-modal-container {
    background: ${props => props.$isDark ? '#1a202c' : '#ffffff'} !important;
  }
`;

export const ModalContainerGlobalStyle = createGlobalStyle<{ $isDark: boolean }>`
  .ant-modal-container {
    background: ${props => props.$isDark ? '#1a202c' : '#ffffff'} !important;
  }
  
  .ant-modal-wrap .ant-modal-container {
    background: ${props => props.$isDark ? '#1a202c' : '#ffffff'} !important;
  }
`;

export const StyledInput = styled(Input)<{ $isDark: boolean }>`
  background: ${props => props.$isDark ? '#2d3748' : '#ffffff'} !important;
  border: 1px solid ${props => props.$isDark ? '#4a5568' : '#d9d9d9'} !important;
  border-radius: 8px;
  color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
  font-size: 16px;
  padding: 8px 12px;
  transition: all 0.2s ease;

  &::placeholder {
    color: ${props => props.$isDark ? '#718096' : '#bfbfbf'} !important;
  }

  &:hover {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
  }

  &:focus {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
    box-shadow: ${props => props.$isDark ? '0 0 0 2px rgba(99, 179, 237, 0.2)' : '0 0 0 2px rgba(24, 144, 255, 0.2)'} !important;
  }

  &:disabled {
    background: ${props => props.$isDark ? '#2d3748' : '#f5f5f5'} !important;
    color: ${props => props.$isDark ? '#718096' : '#bfbfbf'} !important;
    cursor: not-allowed;
  }
`;

// Select with Dark Mode
export const StyledSelect = styled(Select)<{ $isDark: boolean }>`
  .ant-select-selector {
    background: ${props => props.$isDark ? '#2d3748' : '#ffffff'} !important;
    border: 1px solid ${props => props.$isDark ? '#4a5568' : '#d9d9d9'} !important;
    border-radius: 8px !important;
    color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
    font-size: 16px;
    padding: 4px 12px;
    transition: all 0.2s ease;
    min-height: 40px;

    .ant-select-selection-placeholder {
      color: ${props => props.$isDark ? '#718096' : '#bfbfbf'} !important;
    }

    .ant-select-selection-item {
      color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
    }

    .ant-select-selection-search-input {
      color: ${props => props.$isDark ? '#fff' : '#1a1a1a'} !important;
    }
  }

  &:hover .ant-select-selector {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
  }

  &.ant-select-focused .ant-select-selector {
    border-color: ${props => props.$isDark ? '#63b3ed' : '#40a9ff'} !important;
    box-shadow: ${props => props.$isDark ? '0 0 0 2px rgba(99, 179, 237, 0.2)' : '0 0 0 2px rgba(24, 144, 255, 0.2)'} !important;
  }

  .ant-select-arrow {
    color: ${props => props.$isDark ? '#a0aec0' : '#8c8c8c'} !important;
  }

  // Dropdown menu styling
  .ant-select-dropdown {
    background: ${props => props.$isDark ? '#1a202c' : '#ffffff'} !important;
    border-radius: 8px;
    box-shadow: ${props => props.$isDark ? '0 4px 12px rgba(0, 0, 0, 0.5)' : '0 4px 12px rgba(0, 0, 0, 0.15)'} !important;
  }

  .ant-select-item {
    color: ${props => props.$isDark ? '#e2e8f0' : '#262626'} !important;
    
    &:hover {
      background: ${props => props.$isDark ? '#2d3748' : '#f5f5f5'} !important;
    }

    &.ant-select-item-option-selected {
      background: ${props => props.$isDark ? '#2d3748' : '#e6f7ff'} !important;
      color: ${props => props.$isDark ? '#fff' : '#1890ff'} !important;
    }

    &.ant-select-item-option-active {
      background: ${props => props.$isDark ? '#4a5568' : '#f5f5f5'} !important;
    }
  }
`;

// Form Label with Dark Mode
export const StyledFormLabel = styled.span<{ $isDark: boolean }>`
  color: ${props => props.$isDark ? '#e2e8f0' : '#262626'} !important;
  font-size: 14px;
  font-weight: 500;
`;
